jQuery(document).ready(function ($) {
    if ( !$('#employer-create-job').length) {
        return;
    }
    
    const jobRequirement = $('.job-requirement');
    const clinicalSelect = $('#job-category-clinical');
    const nonClinicalSelect = $('#job-category-nonClinical');
    const categoryOther = $('.category-other');

    const clinicalCat = $('.category-clinical');
    const nonClinicalCat = $('.category-nonClinical');

    function toggleJobCategoryDropdown(clinicalCategory, loadChange) {
        clinicalCat.removeClass('d-block').addClass('d-none');
        nonClinicalCat.removeClass('d-block').addClass('d-none');

        $(`.category-${clinicalCategory}`).removeClass('d-none').addClass('d-block');
        categoryOther.removeClass('d-block').addClass('d-none');
        
        $('.divider-line').hide();
        
        if( clinicalCategory == 'other' ) {
            $('.category-initial').each(function () {
                $(this).removeClass('d-block').addClass('d-none');
            });
            $('.item-initial').each(function () {
                $(this).removeClass('d-block').addClass('d-none');
            });
            $(`.job-requirement`).removeClass('d-none').addClass('d-block');
            categoryOther.removeClass('d-none').addClass('d-block');
        } else {
            let selectedClinical = $(`#job-category-${clinicalCategory}`).val();
            let clinicalRole = selectedClinical.toLowerCase().replace(/\s+/g, '-')
            let jobClinical = $('#job-clinical').val();
            let jobRoleCategory = $('#job-role-category').val();

            if( loadChange == 'change' ) {
                jobRequirement.removeClass('d-block').addClass('d-none');
                $('.category-initial').removeClass('d-block').addClass('d-none');
                
                $('.item-initial').each(function () {
                    $(this).removeClass('d-block').addClass('d-none');
                });

                if( jobRoleCategory == '' ) { 
                    clinicalSelect.val('').trigger('change');
                    nonClinicalSelect.val('').trigger('change');

                } else {
                    jobRequirement.addClass('d-block').removeClass('d-none');

                    if( jobClinical == clinicalCategory ) {
                        let setClinicalValue = jobRoleCategory.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
                        $(`#job-category-${jobClinical}`).val(setClinicalValue).trigger('change')
                        if( jobClinical == 'clinical' ) {
                            $('.clinical-initial').addClass('d-block').removeClass('d-none');
                            $(`.item-${jobRoleCategory}`).addClass('d-block').removeClass('d-none');
                            if( clinicalSelect.val() == 'Other' ) {
                                $('.clinical-initial').addClass('d-none').removeClass('d-block');
                            }
                            
                        } else {
                            if( jobRoleCategory == 'receptionist' ) {
                                $('.receptionist-initial').addClass('d-block').removeClass('d-none');
                            }
                            $(`.item-${jobRoleCategory}`).addClass('d-block').removeClass('d-none');
                        }
                    } else {
                        jobRequirement.addClass('d-none');
                        jobRequirement.removeClass('d-block');
                        $(`#job-category-${clinicalCategory}`).val('').trigger('change');
                    }
                }

            } else {
                if( clinicalRole == 'receptionist' ) {
                    $('.receptionist-initial').addClass('d-block').removeClass('d-none');
                }
                if( clinicalCategory == 'clinical' ) {
                    $('.clinical-initial').addClass('d-block').removeClass('d-none');

                }
                
            }

            if( jobRoleCategory == 'receptionist' ) {
                $('.line-2').show();
            } else if( jobRoleCategory == 'veterinarian' ) {
                $('.line-1').show();
            } else if( jobRoleCategory == 'vet-nurse' ) {
                $('.line-1').show();
                $('.line-4').show();
            } else {
                //
            }
        }
    }

    // Init display based on current radio selection
    const initialType = $('input[name="work-type"]:checked').val();
    toggleJobCategoryDropdown(initialType, 'load');

    // Listen to radio change
    $('input[name="work-type"]').on('change', function () {
        toggleJobCategoryDropdown(this.value, 'change');
    });

    // Listen to Select2 select events
    clinicalSelect.on('select2:select', function (e) {
        let selectedSubItem = e.params.data.id;
        selectedSubItem = selectedSubItem.toLowerCase().replace(/\s+/g, '-')
        jobRequirement.addClass('d-block').removeClass('d-none');
        
        clinicalCat.addClass('d-block');
        
        $('.clinical-initial').addClass('d-block').removeClass('d-none');
        $('.category-other').removeClass('d-block').addClass('d-none');
        if( selectedSubItem == 'other' ) {
            $('.clinical-initial').removeClass('d-block').addClass('d-none');
        }

        $('.item-initial').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
        });
        $(`.item-${selectedSubItem}`).addClass('d-block').removeClass('d-none');

        $('.divider-line').hide();
        if( selectedSubItem != 'other' ) {
            if( selectedSubItem == 'vet-nurse' ) {
                $('.line-1').show();
                $('.line-4').show();
            } else {
                $('.line-1').show();
            }
        }
    });
    
    nonClinicalSelect.on('select2:select', function (e) {
        let selectedSubItem = e.params.data.id;
        selectedSubItem = selectedSubItem.toLowerCase().replace(/\s+/g, '-')
        jobRequirement.addClass('d-block');
        jobRequirement.removeClass('d-none');

        $('.clinical-initial').removeClass('d-block').addClass('d-none');
        $('.category-other').removeClass('d-block').addClass('d-none');
        
        $('.item-initial').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
        });
        $(`.item-${selectedSubItem}`).addClass('d-block').removeClass('d-none');

        if( selectedSubItem == 'receptionist' ) {
            $('.receptionist-initial').addClass('d-block').removeClass('d-none');
            $('.item-receptionist').removeClass('d-none');
        } else {
            $('.receptionist-initial').removeClass('d-block').addClass('d-none');
            $('.item-receptionist').addClass('d-none');
        }

        $('.divider-line').hide();
        if( selectedSubItem == 'receptionist' ) {
            $('.line-2').show();
        }
    });
});